// extracted by mini-css-extract-plugin
export default {"root":"InstanceConfig_root__G-wyH","header":"InstanceConfig_header__w+nhM","body":"InstanceConfig_body__iC8UA"};